export default __webpack_public_path__ + "static/media/watch-vault1.123d49c0.svg";